import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import $ from 'jquery';
import uuid from 'uuid';
import DataLoader from '../../app/DataLoader'
import TypeformView from '../training/TypeformView'

class PolicyGenerator extends PureComponent {
  static propTypes = {
    items: PropTypes.object
  };

  state = {
    categoryIndex: 0,
    isActive: true,
    hoverColor: true,
    bgColr: "white-bg",
    loading: true,
    loaded: false,
    updateForm: true,
    forms: []
}

scrollContent (direction) {
    const step = 370;

    $("#card-content").animate({
        scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step + "px"
    });
}

setUpdate = (title, active) => {
    this.setState({ updateForm: (title !== active) })
}

selectNewCatagory (category) {
    this.setState({ categoryIndex: category });
}

componentDidMount () {
    const tenantId = localStorage.getItem('tenant')

    const forms = [
        {
            name: 'Policy Generator',
            url: `https://postured.typeform.com/to/jC20lv?tenantid=${tenantId}`+
            `&frameworkname=policygenerator&frameworkid=5`,
            description: 'Step 3'
        }
    ]

    this.setState({ forms: forms })
}

  render() {
    return (
      <DataLoader>
        <div className="comp-assessment">
            <div>
                <Row>
                    <Col md={12} id="test">
                        <h3 className='page-title'>Policy Generator</h3>
                        {/* <h3 className='page-subhead subhead'>
                            Determine the state of your company's compliance health</h3> */}
                    </Col>
                </Row>
            </div>

            {
                this.state.forms.map((category, idx) => {
                    return <div key={uuid()}><TypeformView
                        categoryIndex={this.state.categoryIndex}
                        i={idx}
                        url={`${category.url}&email=${this.props.user.email}`+
                        `&tenantname=${this.props.tenant ? this.props.tenant.companyName: ""}`} />
                      </div>
                }
                )
            }
        </div >
      </DataLoader>
    );
  }
}


function mapStateToProps (state) {
  return {
      user: state.auth.user,
      tenant: state.auth.tenant,
      enabledFrameworks: state.controlsData.enabledFrameworks,
      dataLoaded: !state.controlsData.loading,
      sidebar: state.sidebar
  }
}

export default connect(mapStateToProps)(withRouter(PolicyGenerator))





// WEBPACK FOOTER //
// ./src/components/policy_generator/PolicyGenerator.js